// src/features/auth/reset-password/services/resetPasswordService.ts

import api from '../../../../api/axios';

import {
  AUTH_ENDPOINTS,
} from '../../../../api';

import type {
  ApiResponse,
} from '../../../../shared/types/api.types';


export type ResetPasswordRequest = {
  userId: string;
  phoneNumber: string;
  verificationToken: string;
  newPassword: string;
};


export type ResetPasswordResponse = {
  success: boolean;
};


/**
 * 비밀번호 재설정
 */
export const resetPassword =
  async (
    request:
      ResetPasswordRequest,
  ): Promise<
    ResetPasswordResponse
  > => {
    const response =
      await api.post<
        ApiResponse<
          ResetPasswordResponse
        >
      >(
        AUTH_ENDPOINTS
          .RESET_PASSWORD,
        request,
      );


    return (
      response.data.data ?? {
        success: true,
      }
    );
  };